import React, { useState } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';

export const BottomPercent = '35%';

const options = [
  { label: 'DOUBT IT', color: '#B0301C' },
  { label: ' ', color: '#F5A623' },
  { label: 'POSSIBLY', color: '#E2CA16' },
  //#E2CA16
  //#84BD09
  { label: ' ', color: '#84BD09' },
  { label: 'ABSOLUTELY', color: '#7ED321' },
];

interface RatingSelectorProps {
  question: string;
  onClick: (value: string) => void;
}

export const RatingSelector: React.FC<RatingSelectorProps> = ({ question, onClick }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const theme = useTheme();
  const handleClick = () => {
    if (typeof selectedIndex === 'number') {
      onClick((selectedIndex + 1).toString());
    }
  };

  return (
    <Box
      style={{
        width: '100%',
        minWidth: '308px',
        margin: '0 auto',
        textAlign: 'center',
        padding: '16px',
        backdropFilter: 'blur(10px)',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: '12px',
      }}
    >
      <Typography style={{ fontSize: '18px', fontWeight: 500, color: '#333', marginBottom: '8px', whiteSpace: 'nowrap' }}>
        {question}
      </Typography>

      <Typography style={{ fontSize: '12px', fontWeight: 600, color: '#888', marginBottom: '16px' }}>TAP TO SELECT</Typography>

      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginBottom: '24px' }}>
        {options.map((opt, i) => {
          const isSelected = selectedIndex === i;

          return (
            <Box
              key={i}
              onClick={() => setSelectedIndex(i)}
              style={{
                cursor: 'pointer',
                textAlign: 'center',
                width: '68px',
                height: '68px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Box
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  border: `6px solid ${opt.color}`,
                  backgroundColor: isSelected ? opt.color : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  transition: 'all 0.3s ease',
                }}
              >
                {isSelected && (
                  <svg
                    viewBox="0 0 24 24"
                    width="30"
                    height="30"
                    style={{ stroke: 'white', strokeWidth: 3, fill: 'none' }}
                  >
                    <path
                      d="M5 13l4 4L19 7"
                      style={{
                        strokeDasharray: 24,
                        strokeDashoffset: 24,
                        animation: 'drawCheck 0.4s ease-out forwards',
                      }}
                    />
                  </svg>
                )}
              </Box>
              <Typography style={{ fontSize: '12px', fontWeight: 700, color: '#475467', marginTop: '8px', height: '13px' }}>
                {opt.label}
              </Typography>
            </Box>
          );
        })}
      </Box>

      <Button
        variant="contained"
        fullWidth
        disabled={selectedIndex === null}
        onClick={handleClick}
        style={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontWeight: 600,
          fontSize: '16px',
          borderRadius: '8px',
          textTransform: 'none',
          paddingTop: '9.6px',
          paddingBottom: '9.6px',
        }}
      >
        Next
      </Button>

      {/* Keyframes for checkmark drawing */}
      <style>
        {`
          @keyframes drawCheck {
            to {
              stroke-dashoffset: 0;
            }
          }
        `}
      </style>
    </Box>
  );
};
